var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation } from '@apollo/client/react';
import { t } from '@lingui/core/macro';
import { useToast } from '@pocketlaw/tetris';
import { parseGraphqlResult } from 'shared/domains/apollo/parseGraphqlResult';
import { DeleteContactDocument } from './DeleteContact.gql';
import { ContactLibraryListDocument } from '../ContactLibraryList.gql';
export function useDeleteContact(callback) {
    const [mutate, status] = useMutation(DeleteContactDocument);
    const { addToast } = useToast();
    const handleDelete = (id) => __awaiter(this, void 0, void 0, function* () {
        try {
            yield mutate({
                variables: { id },
                update(cache, result) {
                    var _a;
                    const [payload, rejection] = parseGraphqlResult((_a = result.data) === null || _a === void 0 ? void 0 : _a.deleteEsigningRecipientValue, 'DeleteEsigningRecipientValuePayload', 'DeleteEsigningRecipientValueRejectionList');
                    if (rejection) {
                        throw new Error();
                    }
                    if (payload) {
                        cache.modify({
                            id: cache.identify({ id, __typename: 'EsigningRecipientValue' }),
                            fields(_, { DELETE }) {
                                return DELETE;
                            },
                        });
                        addToast({
                            appearance: 'success',
                            title: t({
                                message: 'Contact deleted',
                                comment: 'Contact library - Contact deleted toast',
                            }),
                        });
                        callback();
                    }
                },
                refetchQueries: [ContactLibraryListDocument],
            });
        }
        catch (_a) {
            addToast({
                appearance: 'danger',
                title: t({
                    message: 'Failed to delete contact',
                    comment: 'Contact library - Unknown API error when deleting contact',
                }),
            });
        }
    });
    return [handleDelete, status];
}
